// Selectors
export const getSpellCheckStatus = (state) => state.getIn(['app', 'electron', 'spellCheck']);
export const getElectronCloseMessage = (state) => state.getIn(['app', 'electron', 'closeMessage']);
